import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
    name: 'courses-tooltip',
    computed: {
        ...mapGetters({
            list: 'courses/newCourses',
            loading: 'courses/isLoadingNewCourses',
            userHomework: `userHomework/list`
        }),
        getSomeCountCourses() {
            return this.list
        },
        showLabelMore() {
            if (this.list) {
                return !this.loading;
            }
            return false;
        }
    },
    created() {
        if (!this.list) {
            this.fetchList();
        }
    },
    methods: {
        ...mapActions({
            fetchList: 'courses/FETCH_NEW_COURSES'
        }),
        ...mapMutations({
            changeShowTooltip: `header/HEADER_COURSES_SHOW_TOOLTIP`
        }),
        getCourseProgress(complete = 0, total = 0) {
            return Math.round(complete * 100 / total) || 0;
        }
    }
}
